export const portfolioData = {
  name: 'Anuj Kumar',
  role: 'Software Developer',
  tagline: 'Building scalable Java Spring Boot & MERN full-stack web applications, real-time backend systems, and modern software products.',
  summary:
    'Software Developer and 2026 pass-out targeting Graduate Trainee – Digital roles, with experience building scalable web applications and REST APIs using Java, Spring Boot, Spring Security, React.js, Next.js, Node.js, and Express.js. Demonstrated track record of optimizing backend performance, achieving sub-200ms latency, and managing cloud infrastructure handling 50+ monthly redirects on AWS. Strong collaborative foundation in Data Structures, Algorithms, System Design, DBMS, and CI/CD automation.',
  links: {
    email: 'mailto:anujyadav11112003@gmail.com',
    calendar: 'https://calendly.com/anujyadav11112003',
    linkedin: 'https://www.linkedin.com/in/anuj-kumar-918415295/',
    github: 'https://github.com/AnujYadav-1915',
    leetcode: 'https://leetcode.com/u/AnujxPhoenix/',
    codechef: 'https://www.codechef.com/users/clean_array_61',
    portfolio: 'https://anujyadav-1915.github.io/updated-portfolio-website/',
    resume: './AnujKumarResume.pdf',
  },
  experience: [
    {
      company: 'Quizzoc',
      role: 'Software Developer',
      type: 'Remote',
      duration: 'Jan 2024 — Mar 2024',
      summary: 'Engineered full-stack features via Java Spring Boot & MERN stack, boosting page load speeds by 10% using lazy loading and API optimization.',
      points: [
        'Engineered full-stack features via Java Spring Boot and MERN stack, boosting page load speeds by 10% using lazy loading and API optimization.',
        'Built secure REST APIs and MongoDB models with authentication and logging for platforms serving 50+ monthly active users.',
        'Refactored reusable React components across 6+ pages, minimizing code duplication and enhancing overall maintainability.',
        'Collaborated across cross-functional teams via Git branching and pull requests to deliver 8+ feature enhancements in Agile sprints.',
      ],
    },
  ],
  certifications: [
    { name: 'Walmart Advanced Software Engineering (Forage)', icon: '🛒', pdf: process.env.PUBLIC_URL + '/certs/Walmart-Advanced-Software-Engineering-Forage.pdf' },
    { name: 'Citi Software Development (Forage)', icon: '🏦', pdf: process.env.PUBLIC_URL + '/certs/Citi-Software-Development-Forage.pdf' },
    { name: 'AWS Cloud Practitioner', icon: '☁️', pdf: process.env.PUBLIC_URL + '/certs/AWS-Cloud-practitioner-Certificate.pdf' },
    { name: 'AWS AI Practitioner', icon: '🤖', pdf: process.env.PUBLIC_URL + '/certs/AWS-AI-Practitioner-certificate.pdf' },
    { name: 'AWS Machine Learning', icon: '🧠', pdf: process.env.PUBLIC_URL + '/certs/AWSMLCertificate.pdf' },
    { name: 'AWS Training & Skill Builder (7 Badges)', icon: '⚡' },
    { name: 'AI Outskill Certificate', icon: '✨', pdf: process.env.PUBLIC_URL + '/certs/AIOutskillCertificate.pdf' },
    { name: 'JS DSA (freeCodeCamp)', icon: '📜', pdf: process.env.PUBLIC_URL + '/certs/freecodecamp.org_certification_javascript-algorithms-and-data-structures-v8.pdf' },
    { name: 'Front-End Libraries (freeCodeCamp)', icon: '⚛', pdf: process.env.PUBLIC_URL + '/certs/freecodecamp.org_certification_front-end-development-libraries.pdf' },
    { name: 'Data Visualization (freeCodeCamp)', icon: '📈', pdf: process.env.PUBLIC_URL + '/certs/freecodecamp.org_certification_data-visualization.pdf' },
    { name: 'Responsive Web Design (freeCodeCamp)', icon: '🌐', pdf: process.env.PUBLIC_URL + '/certs/freecodecamp.org_certification_responsive-web-design.pdf' },
  ],
  skills: {
    languages: ['Java', 'JavaScript', 'TypeScript', 'C++', 'Python', 'SQL'],
    frontend: ['React.js', 'Next.js', 'HTML5', 'CSS3', 'Tailwind CSS', 'Bootstrap'],
    backend: ['Java', 'Spring Boot', 'Spring Framework', 'Spring Security', 'Spring Data JPA', 'Hibernate', 'RESTful APIs', 'Microservices', 'Node.js', 'Express.js', 'WebSockets', 'GraphQL', 'JWT', 'RBAC'],
    databases: ['MySQL', 'PostgreSQL (Neon)', 'MongoDB', 'Redis'],
    tools: ['Maven', 'AWS (EC2, S3, Lambda)', 'Docker', 'Git', 'Postman', 'Swagger/OpenAPI', 'Vercel', 'Render'],
    fundamentals: ['Data Structures & Algorithms', 'System Design', 'OOP', 'DBMS', 'Operating Systems', 'Computer Networks'],
  },
  projects: [
    {
      title: 'TaskFlow — Employee & Task Management System',
      category: 'React 18 • Vite • Java 17 • Spring Boot 3.1 • Kafka • Redis • Docker',
      image: process.env.PUBLIC_URL + '/project-task-management.png',
      stack: ['React 18', 'Vite', 'Java 17', 'Spring Boot 3.1', 'Spring Security', 'JPA/Hibernate', 'Apache Kafka', 'Redis', 'Docker', 'Spring Cloud Gateway'],
      demoLink: 'https://taskflow-frontend-217j.onrender.com',
      repoLink: 'https://github.com/AnujYadav-1915/Employee-Task-Management-System',
      caseStudy: {
        problem: 'Teams required an enterprise task management platform with low API latency, real-time Kanban tracking, and role-based permissions.',
        architecture: 'React 18 (Vite) frontend with Java 17 & Spring Boot 3.1 backend, Spring Cloud Gateway, Apache Kafka event streaming, Redis caching, and Docker on Render.',
        result: 'Reduced backend API response latency by 42%, cut initial frontend load time by 55%, and streamlined team workflow management by 35%.',
      },
      points: [
        'Architected a full-stack employee & task management platform with React 18 (Vite) and Spring Boot 3.1, reducing backend API response latency by 42% through stateless JWT authentication with Spring Security and optimized JPA/Hibernate queries.',
        'Cut frontend initial load time by 55% and shrank the production bundle to under 180KB after migrating the build pipeline to Vite.',
        'Built real-time Kanban task boards, an employee directory, and a notification audit stream with Role-Based Access Control across Employee, Manager, and Admin roles, streamlining team workflow management by 35%.',
        'Deployed a Dockerized, memory-capped Java backend alongside the React frontend on Render at zero hosting cost, routing services through Spring Cloud Gateway and integrating Apache Kafka for event streaming.',
      ],
    },
    {
      title: 'Real-Time Collaborative Code Editor',
      category: 'React • Node.js • WebSockets',
      image: process.env.PUBLIC_URL + '/project-code-editor.png',
      stack: ['React', 'Node.js', 'WebSockets', 'Monaco Editor'],
      demoLink: 'https://realtime-collaborative-code-editor-master.onrender.com/',
      repoLink: 'https://github.com/AnujYadav-1915/Realtime-Collaborative-Code-Editor-master',
      caseStudy: {
        problem: 'Teams required synchronized code editing with real-time updates and sub-200ms latency across distributed clients.',
        architecture: 'React + Node.js backend with event-driven WebSocket synchronization pipelines.',
        result: 'Supported 10+ simultaneous users with sub-200ms latency, boosting responsiveness and user retention.',
      },
      points: [
        'Led development of a concurrent collaboration engine supporting 10+ simultaneous users with sub-200ms latency.',
        'Architected event-driven synchronization pipelines, ensuring data consistency across distributed clients.',
        'Optimized frontend rendering and network calls, boosting system responsiveness and user retention.',
      ],
    },
    {
      title: 'LearnMate – AI Career Platform',
      category: 'React • Node.js • Python • MongoDB',
      image: process.env.PUBLIC_URL + '/project-ai-coach.png',
      stack: ['React', 'Node.js', 'Python', 'MongoDB', 'Clerk', 'Inngest', 'PostgreSQL'],
      demoLink: 'https://ai-career-coach-agent-five.vercel.app/',
      repoLink: 'https://github.com/AnujYadav-1915/Learnmate',
      caseStudy: {
        problem: 'Job seekers needed automated resume analysis, interview preparation, and secure role-based access control.',
        architecture: 'Java Spring Boot, React & Node.js application with Python services, MongoDB, JWT RBAC, and automated CI/CD pipelines.',
        result: 'Served 40+ active users with multi-layer authentication and 99% production deployment uptime.',
      },
      points: [
        'Spearheaded an AI-powered platform for automated resume analysis and interview prep for 40+ users.',
        'Integrated secure multi-layer authentication and role-based access control (RBAC) infrastructure using JWT.',
        'Managed production-grade backend deployment pipelines via CI/CD, achieving 99% system uptime.',
      ],
    },
    {
      title: 'URL Shortener (Vynkify)',
      category: 'Node.js • Express • Redis • MongoDB',
      image: process.env.PUBLIC_URL + '/project-url-shortener.png',
      stack: ['Node.js', 'Express', 'Redis', 'MongoDB'],
      demoLink: 'https://frontend-rust-ten-44.vercel.app/',
      repoLink: 'https://github.com/AnujYadav-1915/URL-Shortener',
      caseStudy: {
        problem: 'Needed a reliable URL shortening service capable of handling redirects with low latency and zero key collisions.',
        architecture: 'Node.js/Express service with MongoDB persistence and custom Redis caching strategies.',
        result: 'Handled 50+ monthly redirects with a 10% latency decrease and zero packet loss.',
      },
      points: [
        'Constructed a reliable URL shortener handling 50+ monthly redirects with robust error handling and monitoring.',
        'Decreased system latency by 10% via custom Redis caching strategies and targeted database query optimization.',
        'Devised a distributed unique ID generation mechanism, guaranteeing collision-free key mapping at scale.',
      ],
    },
  ],
  education: [
    {
      institute: 'JSS Academy of Technical Education, Noida',
      degree: 'Bachelor of Technology (B.Tech)',
      specialization: 'Electronics & Communication Engineering',
      duration: 'Nov 2022 — Jul 2026',
      location: 'Noida, Uttar Pradesh, India',
    },
    {
      institute: 'Army Public School (APS)',
      degree: 'Senior Secondary Certificate (CBSE - 94.6%)',
      specialization: 'Engineering Science',
      duration: 'Apr 2020 — Jul 2021',
      location: 'India',
    },
  ],
  achievements: [
    'Solved 500+ Data Structures & Algorithms problems across LeetCode, CodeChef, and GeeksforGeeks.',
    'Completed Walmart Global Tech & Citi Advanced Software Engineering job simulations via Forage.',
    'AWS Certified Cloud Practitioner, AWS AI Practitioner, AWS Machine Learning, and 7 AWS training badges.',
    'FreeCodeCamp Certified (5x): Responsive Web Design, JS Algorithms & Data Structures, Front End Libraries, Data Visualization, Back End APIs.',
  ],
  nowBuilding: [
    {
      title: 'AI Interview Copilot Flows',
      status: 'In Progress',
      details: 'Improving adaptive follow-up questioning and feedback loops for mock interviews.',
      timeline: 'Current Focus',
    },
    {
      title: 'Scalable Realtime Backend Patterns',
      status: 'R&D',
      details: 'Experimenting with socket event partitioning and resilience patterns under high concurrency.',
      timeline: 'This Quarter',
    },
    {
      title: 'Portfolio Case Study Expansion',
      status: 'Planned',
      details: 'Publishing deeper architecture and decision notes for flagship projects.',
      timeline: 'Next Milestone',
    },
  ],
};
